import { SegmentedControl, SegmentedItemOption } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { ChatTabsSC } from './chat-tabs.styled';

type TOption = SegmentedItemOption<string>;

type TProps = {
  selected: string;
  onChange(v: string): void;
  isVideo?: boolean;
  style?: React.CSSProperties;
};

const ChatTabs: React.FC<TProps> = (props) => {
  const { isVideo, onChange, selected, style } = props;
  const { formatMessage } = useIntl();

  const ops = React.useMemo<TOption[]>(() => {
    const ret: TOption[] = [
      {
        value: 'CHAT',
        label: 'chat_tabs.chat',
        key: 'chat',
      },
      {
        value: 'NOTES',
        label: 'chat_tabs.notes',
        key: 'notes',
      },
      {
        value: 'ATTACHMENTS',
        label: 'chat_tabs.attachments',
        key: 'attachments',
      },
    ];

    if (isVideo) {
      ret.unshift({
        value: 'VIDEO',
        label: 'chat_tabs.video',
        key: 'video',
      });
    }

    if (process.env.REACT_APP_SHOW_TOOLS_TAB === 'true') {
      ret.push({
        value: 'TOOLS',
        label: 'chat_tabs.tools',
        key: 'tools',
      });
    }

    return ret.map((o) => ({ ...o, label: formatMessage({ id: o.label as string }) }));
  }, [isVideo, formatMessage]);

  return (
    <ChatTabsSC style={style}>
      <SegmentedControl options={ops} onChange={onChange} value={selected} style={{ height: 40 }} />
    </ChatTabsSC>
  );
};

export default ChatTabs;
